import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitTaskQueueModel, IUnitTaskQueueSearchParamsModel } from '@apps-common/types/portal/unit-tasks'

export const QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE = (taskGroupId?: number, model?: IUnitTaskQueueSearchParamsModel) =>
  ['searchUnitTaskQueue', taskGroupId, model?.status, model?.startDate, model?.endDate, model?.skip, model?.take, model?.orderBy].filter(
    Boolean
  )

export const searchUnitTaskQueue = async (taskGroupId: number, model: IUnitTaskQueueSearchParamsModel): Promise<IUnitTaskQueueModel[]> =>
  axios.post('/management/UnitProgramTask/SearchTaskQueue', { taskGroupId, ...model }).then((res) => res.data?.data)

type QueryFnType = typeof searchUnitTaskQueue

type Props = {
  config?: QueryConfig<QueryFnType>
  taskGroupId: number
  model: IUnitTaskQueueSearchParamsModel
}

export const useManagementSearchUnitTaskQueue = ({ config, taskGroupId, model }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, staleTime: 0, gcTime: 0 },
    queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE(taskGroupId, model),
    queryFn: () => searchUnitTaskQueue(taskGroupId, model)
  })
